import React, { useState, useEffect } from "react";
import "../Styles/Article.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { API_ROOT, webPath } from "../apiConfig";
import getYouTubeID from "get-youtube-id";
import { Helmet, HelmetProvider } from "react-helmet-async";
import LazyLoad from "react-lazyload";
import shareIcon from "../Images/shareIcon.png";
import SocialShare from "../Components/SocialShare";
import DocumentMeta from 'react-document-meta';
import { getAdImageUrl } from "../ReusableComp/getAdImageUrl";

import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import AdCarousel from "../ReusableComp/Carasoul";
import Accordian from "../ReusableComp/Accordian";

const Searchart = ({ src }) => {

  const [isFixed, setIsFixed] = useState(false);
  const [postloading, setPostLoading] = useState(true);
  const [htmlContent, setHtmlContent] = useState("");
  const [authorId, setAuthorId] = useState("");
  const [postData, setPostData] = useState([]);
  const [latestPosts, setLatestPosts] = useState([]);
  const { cat_slug, post_name } = useParams();




  useEffect(() => {
    const fetchData = async () => {
      try {
        setPostLoading(true);
        // Run both fetches in parallel
        const [ipResponse, postResponse] = await Promise.all([
          fetch("https://api64.ipify.org?format=json"),
          fetch(`${API_ROOT}/api/post/postdetails/${cat_slug}/${post_name}`),
        ]);

        // Check for IP response
        if (!ipResponse.ok) {
          throw new Error(`Failed to fetch IP address: ${ipResponse.status}`);
        }

        const ipData = await ipResponse.json();
        const userIp = ipData.ip;
        setUserIp(userIp);

        // Check for post data response
        if (!postResponse.ok) {
          window.location.href = "/404";
          return;
        }

        const data = await postResponse.json();
        const post = data.result[0];

        setHtmlContent(post.post_content);
        setAuthorId(post.post_author_id);
        setPostData(data.result);

        // Optional: Log post date
        const formattedDate = new Date(post.post_date).toISOString().replace(/\.\d{3}Z$/, "+00:00");
        console.log(formattedDate, "hello");

        // Send post view count
        const postDataForCount = {
          postId: post.id,
          ip_addr: userIp,
        };

        const countResponse = await fetch(`${API_ROOT}/api/post/post_count/${post.id}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(postDataForCount),
        });

        if (!countResponse.ok) {
          throw new Error(`View count error: ${countResponse.status}`);
        }

        // You may use this response if needed
        // const countData = await countResponse.json();

      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setPostLoading(false);
      }
    };

    fetchData();
  }, [cat_slug, post_name]);


  useEffect(() => {
    const handleScroll = () => {
      const offsetTop = 200; // Adjust this value based on where you want the div to become fixed
      if (window.scrollY > offsetTop) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);



  useEffect(() => {
    const fetchData = async () => {
      try {
        // Get the current URL
        const currentURL = 'https://enterprisetalk.com' + window.location.pathname;
        // const currentURL = `https://enterprisetalk.com/${cat_slug}/${post_name}`;

        // Make a POST request to the API
        const response = await fetch(`${API_ROOT}/api/url_redirect/check_redirect`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ current_url: currentURL })
        });
        //  console.log(currentURL)

        // Check if the response is successful
        if (response.ok) {
          const data = await response.json();
          const redirectURL = data.urlDetails[0].redirect_url;
          console.log({ redirectURL });
          // If the API returns a redirect URL, redirect the page
          if (redirectURL) {
            window.location.href = redirectURL;
          }
        } else {
          console.error('Failed to fetch data:', response.statusText);
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchData();
  }, []);


  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setIsLoaded(true);
    };

  }, [src]);


  const [className, setClassName] = useState("");
  const [className1, setClassName1] = useState("");
  const [className2, setClassName2] = useState("");

  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {
      const removeTimer = setTimeout(() => {
        setClassName("");
      }, 0);

      const setTimer = setTimeout(() => {
        setClassName("loaded");
        currentSection++;

        if (currentSection <= sections) {
          setSectionClassName();
        }
      }, currentSection * 30);

      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    setSectionClassName();
  }, []);

  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {
      const removeTimer = setTimeout(() => {
        setClassName1("");
      }, 0);

      const setTimer = setTimeout(() => {
        setClassName1("loaded1");
        currentSection++;

        if (currentSection <= sections) {
          setSectionClassName();
        } else {
          window.removeEventListener("scroll", handleScroll);
        }
      }, currentSection * 150);

      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    const handleScroll = () => {
      if (window.scrollY > 100) {
        setSectionClassName();
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const sections = 5;
    let currentSection = 1;

    const setSectionClassName = () => {
      const removeTimer = setTimeout(() => {
        setClassName2("");
      }, 0);

      const setTimer = setTimeout(() => {
        setClassName2("loaded2");
        currentSection++;

        if (currentSection <= sections) {
          setSectionClassName();
        } else {
          // Remove scroll event listener if currentSection * 190 is reached
          window.removeEventListener("scroll", handleScroll);
        }
      }, currentSection * 190);

      return () => {
        clearTimeout(removeTimer);
        clearTimeout(setTimer);
      };
    };

    console.log("currentAd :", currentAd)
    const handleScroll = () => {
      // Add your logic here to determine when to trigger the code based on scroll
      if (window.scrollY > 190) {
        // Example condition: execute code when scrolled more than 100 pixels
        setSectionClassName();
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };



  // const [postId, setPostId] = useState("");
  const [userIp, setUserIp] = useState("");
  const [faqData, setFaqData] = useState([]);

  const output = postData[0]?.id;

  console.log("output :", output);






  //krishna 
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Make a POST request to the API
        const response = await fetch(`${API_ROOT}/api/post/faq/${output}`);

        const data = await response.json();
        setFaqData(data.postDataFaq);

      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchData();
  }, [postData]);

  //krishna

  useEffect(() => {
    // Fetch data from the API using Axios
    axios
      .get(`${API_ROOT}/api/post/latest`)
      .then((response) => {
        setLatestPosts(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []); // Empty dependency array to run the effect once on mount

  const [data, setData] = useState([]);
  // const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ROOT}/api/post/asidetopic/${cat_slug}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        // const removeHtmlTags = (html) => html.replace(/<[^>]*>/g, "");
        const removeHtmlTags = (html) => {
          // Remove HTML tags
          let cleaned = html.replace(/<[^>]*>/g, '');
          // Replace non-breaking space and em dash with regular space
          cleaned = cleaned.replace(/&nbsp;/g, ' ').replace(/&ndash;/g, '—');
          // Replace HTML entities like &rsquo; with their decoded characters
          cleaned = cleaned.replace(/&rsquo;/g, "'");
          // Return the cleaned string
          return cleaned;
        };
        const result = await response.json();
        setData(
          result.result.map((post) => ({
            ...post,
            post_content: removeHtmlTags(post.post_content),
          }))
        );
        // console.log(result)
      } catch (error) { }
    };

    fetchData();
  }, []);

  const [advertisementData, setAdvertisementData] = useState([]);
  const [reportAdData, setReportAdData] = useState([]);
  const [footerAd, setFooterAd] = useState([]);


  useEffect(() => {
    const fetchAdvertisementData = async () => {
      try {
        const response = await axios.get(
         getAdImageUrl(`${API_ROOT}`)
        );
        setAdvertisementData(response.data);
        setReportAdData(response.data.filter(item => item.banner_type === "Post-1"))
        setFooterAd(response.data.filter(item => item.banner_type === "Footer-3"))
        // console.log(response.data)
      } catch (error) {
        console.error("Error fetching advertisement data:", error);
      }
    };

    fetchAdvertisementData();
  }, []); // The empty dependency array ensures that this effect runs once when the component mounts
  console.log("reportAdData :", reportAdData)
  const [authorData, setAuthorData] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  //Krishna
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    if (!reportAdData || reportAdData.length === 0) return;
    setCurrentIndex((prevIndex) =>
      prevIndex === reportAdData.length - 1 ? 0 : prevIndex + 1
    );
  }, [reportAdData]);

  const currentAd = reportAdData[currentIndex];

  //Krishna

  useEffect(() => {
    const fetchAuthorData = async () => {
      try {
        setLoading(true); // Set loading state to true before fetching data

        const response = await axios.get(`${API_ROOT}/api/author/${authorId}`);
        setAuthorData(response.data.result[0]);
      } catch (error) {
        console.error("Error fetching author data:", error.message);
        // Handle error state if needed
      } finally {
        setLoading(false); // Update loading state after fetching data
      }
    };

    if (authorId) {
      // Check if authorId is truthy
      fetchAuthorData();
    }
  }, [authorId]);

  const [headings, setHeadings] = useState([]);

  useEffect(() => {
    const container = document.createElement("div");
    container.innerHTML = htmlContent;

    let index = 1;
    let subIndex = 0;

    const headingsList = Array.from(
      container.querySelectorAll("h1, h2, h3")
    ).map((heading, i) => {
      let text = heading.innerText;
      let id = heading.id || `heading-${i}`;

      if (heading.tagName === "H2") {
        text = (
          <span style={{ fontWeight: "600" }}>
            {index}. {text}
          </span>
        );
        index++;
        subIndex = 0; // Reset subindex for each new H2
      } else if (heading.tagName === "H3") {
        subIndex++;
        // text = `${index - 1}.${subIndex} ${text}`;
        text = (
          <span style={{ marginLeft: "20px" }}>
            {index - 1}.{subIndex} {text}
          </span>
        );
      }
      return {
        text: text,
        id: id,
      };
    });

    setHeadings(headingsList);
  }, [htmlContent]);

  // const scrollToHeading = (id) => {
  //   const element = document.getElementById(id);
  //   // console.log('scrollToHeading called with id:', id);

  //   if (element) {
  //     // console.log('Element found:', element);
  //     element.scrollIntoView({ behavior: "smooth" });
  //     // window.scrollBy(0, -130);
  //     setTimeout(() => {
  //       window.scrollBy(0, -140); // Adjust the value (-100) to set the desired distance from the top
  //     }, 700); // Adjust the delay if needed to ensure it's after the smooth scrolling
  //   } else {
  //     console.log("Element not found with id:", id);
  //   }
  // };


  const scrollToHeading = (id) => {
    const element = document.getElementById(id);

    if (element) {
      if (window.innerWidth <= 768) { // Mobile condition
        element.scrollIntoView({ behavior: "smooth" });
        setTimeout(() => {
          window.scrollBy(0, -130); // Adjust the value for mobile devices
        }, 700); // Adjust the delay if needed to ensure it's after the smooth scrolling
      } else { // Default condition for non-mobile devices
        element.scrollIntoView({ behavior: "smooth" });
        setTimeout(() => {
          window.scrollBy(0, -140); // Adjust the value for non-mobile devices
        }, 700); // Adjust the delay if needed to ensure it's after the smooth scrolling
      }
    } else {
      console.log("Element not found with id:", id);
    }
  };
  console.log("currentAd :", currentAd)



  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlContent;

  // Get all h1, h2, h3 elements
  const heading = tempDiv.querySelectorAll("h2, h3");



  console.log("hELLO")

  // Loop through the headings and assign dynamic IDs
  heading.forEach((heading, index) => {
    heading.id = `heading-${index + 0}`; // You can change the ID format as per your requirement
  });

  // Set the modified HTML content back
  const updatedHtmlContent = tempDiv.innerHTML;

  const [accordionOpen, setAccordionOpen] = useState(false);

  // const openAccordion = () => {
  //   setAccordionOpen(true);
  // };

  // const closeAccordion = () => {
  //   setAccordionOpen(false);
  // };

  const handleHeaderClick = () => {
    setAccordionOpen(!accordionOpen);
  };

  const handleLinkClick = (e) => {
    e.stopPropagation(); // Prevent the accordion from closing when clicking on a link
  };

  const [activeHeadingId, setActiveHeadingId] = useState(null);
  // console.log("actived",activeHeadingId)

  if (!postData || postData.length === 0) {
    return null; // Or you can render a placeholder or loading indicator
  }

  // Extract the YouTube video ID if the podcast link is available
  const videoId = postData[0].podcast_link
    ? getYouTubeID(postData[0].podcast_link)
    : "";

  const canonicalUrl = `https://enterprisetalk.com/${cat_slug}/${post_name}`;

  const schemaData = {
    "@context": "http://schema.org",
    "@type": "NewsArticle",
    headline: postData[0].post_title,
    description: postData[0].meta_description,
    datePublished: new Date(postData[0].post_date).toLocaleDateString(
      undefined,
      options
    ),
    dateModified: new Date(postData[0].post_date).toLocaleDateString(
      undefined,
      options
    ),
    author: {
      "@type": "Person",
      name: postData[0].post_author,
    },
    publisher: {
      "@type": "Organization",
      name: "Enterprise Talk",
      logo: {
        "@type": "ImageObject",
        url: "https://enterprisetalk.com/static/media/enterpriseLogo.0c9f185de2e44cf44932.webp",
      },
    },
    image: {
      "@type": "ImageObject",
      url: `${webPath}${postData[0]?.banner_img}`,
      height: "844 px",
      width: "1500 px",
    },
    articleBody: "Full text of the article",
  };



  const schemaData2 = {
    "@context": "http://schema.org",
    "@type": "CreativeWork",
    headline: postData[0].post_title,
    author: postData[0].post_author,
    datePublished: new Date(postData[0].post_date).toLocaleDateString(
      undefined,
      options
    ),
    description: postData[0].meta_description,
  };

  const schemaData3 = {
    "@context": "http://schema.org",
    "@type": "SocialMediaPosting",
    headline: postData[0].post_title,
    datePublished: (new Date(postData[0]?.post_date).toISOString().replace(/\.\d{3}Z$/, '+00:00')
    ),
    author: {
      "@type": "Person",
      name: postData[0].post_author,
    },
    publisher: {
      "@type": "Organization",
      name: "Enterprise Talk",
      logo: {
        "@type": "ImageObject",
        url: "https://enterprisetalk.com/static/media/enterpriseLogo.0c9f185de2e44cf44932.webp",
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": canonicalUrl,
    },
    "text": postData[0].meta_description,
};

const schemaData4 = {
  "@context": "http://schema.org",
  "@type": "ImageObject",
  url: `${webPath}${postData[0]?.banner_img}`,
  caption: "",
  description: postData[0].meta_description,
};

//krishna
// const schemaData1 = {
//   "@context": "https://schema.org",
//   "@type": "FAQPage",
//   "mainEntity": faqData.map(faq => ({
//     "@type": "Question",
//     "name": faq.faq_que,
//     "acceptedAnswer": {
//       "@type": "Answer",
//       "text": faq.faq_ans
//     }
//   }))
// };

//krishna

let schemaData5;

if (postData[0].podcast_link) {
  schemaData5 = {
    "@context": "http://schema.org",
    "@type": "VideoObject",
    name: postData[0].post_title,
    description: postData[0].meta_description,
    duration: postData[0].reading_time, // Replace with actual video duration
    thumbnailUrl: `${webPath}${postData[0]?.banner_img}`,
    uploadDate: postData[0].post_date,
    contentUrl: postData[0].podcast_link,
    publisher: {
      "@type": "Organization",
      name: "Enterprise Talk",
      logo: {
        "@type": "ImageObject",
        url: "https://enterprisetalk.com/static/media/enterpriseLogo.0c9f185de2e44cf44932.webp",
      },
    },
  };
}
const schemaData6 = {

  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Article",
      "isPartOf": {
        "@id": `"${postData[0].id}"`
      },
      "author": {
        "@name": postData[0].post_author,
        "@id": "https://enterprisetalk.com/#/schema/person/b6fc11afad1183e55c833fd729553f60"
      },
      headline: postData[0].meta_description,
      datePublished: postData[0].post_date,
      dateModified: postData[0].post_date,
      "mainEntityOfPage": {
        "@id": `"${postData[0].id}"`
      },
      "wordCount": 132,
      "commentCount": 0,
      "publisher": {
        "@id": "https://enterprisetalk.com/#organization"
      },
      "image": {
        "@id": `${webPath}${postData[0]?.banner_img}`
      },
      "thumbnailUrl": `${webPath}${postData[0]?.banner_img}`,
      "keywords": [
        postData[0].meta_keywords
      ],
      "inLanguage": "en-US",
      "potentialAction": [
        {
          "@type": "CommentAction",
          "name": "Comment",
          "target": [
            postData[0].post_title
          ]
        }
      ]
    },
    {
      "@type": "WebPage",
      "@id": postData[0].post_title,
      "url": postData[0].post_title,
      "name": postData[0].meta_description,
      "isPartOf": {
        "@id": "https://enterprisetalk.com/#website"
      },
      "primaryImageOfPage": {
        "@id": postData[0].post_title
      },
      "image": {
        "@id": postData[0].post_title
      },
      "thumbnailUrl": `${webPath}${postData[0].banner_img}`,
      "datePublished": postData[0].post_date,
      "dateModified": postData[0].post_date,
      "description": postData[0].meta_description,
      "breadcrumb": {
        "@id": postData[0].post_title
      },
      "inLanguage": "en-US",
      "potentialAction": [
        {
          "@type": "ReadAction",
          "target": [
            postData[0].post_title
          ]
        }
      ]
    },
    {
      "@type": "ImageObject",
      "inLanguage": "en-US",
      "@id": postData[0].post_title,
      "url": `${webPath}${postData[0]?.banner_img}`,
      "contentUrl": `${webPath}${postData[0]?.banner_img}`,
      "width": 1921,
      "height": 1080,
      "caption": postData[0].meta_description
    },
    {
      "@type": "BreadcrumbList",
      "@id": postData[0].post_title,
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://enterprisetalk.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": postData[0].meta_description
        }
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://enterprisetalk.com/#website",
      "url": "https://enterprisetalk.com/",
      "name": "Enterprise Talk",
      "description": "A Peer Knowledge Resource Expert inputs on challenges, triumphs ; innovative solutions from corporate Movers ; Shakers in global Leadership.",
      "publisher": {
        "@id": "https://enterprisetalk.com/#organization"
      },
      "potentialAction": [
        {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://enterprisetalk.com/?s={search_term_string}"
          },
          "query-input": {
            "@type": "PropertyValueSpecification",
            "valueRequired": true,
            "valueName": "search_term_string"
          }
        }
      ],
      "inLanguage": "en-US"
    },
    {
      "@type": "Organization",
      "@id": "https://enterprisetalk.com/#organization",
      "name": "Enterprise Talk",
      "url": "https://enterprisetalk.com/",
      "logo": {
        "@type": "ImageObject",
        "inLanguage": "en-US",
        "@id": "https://enterprisetalk.com/#/schema/logo/image/",
        "url": "https://enterprisetalk.com/static/media/enterpriseLogo.0c9f185de2e44cf44932.webp",
        "contentUrl": "https://enterprisetalk.com/static/media/enterpriseLogo.0c9f185de2e44cf44932.webp",
        "width": 1437,
        "height": 407,
        "caption": "EnterpriseTalk"
      },
      "image": {
        "@id": "https://enterprisetalk.com/#/schema/logo/image/"
      },
      "sameAs": [
        "https://www.facebook.com/enterprisetalk",
        "https://x.com/enterprise_talk",
        "https://www.linkedin.com/company/enterprisetalk"
      ]
    },
    {
      "@type": "Person",
      "@id": "https://enterprisetalk.com/#/schema/person/b6fc11afad1183e55c833fd729553f60",
      "name": postData[0].post_author,
      "image": {
        "@type": "ImageObject",
        "inLanguage": "en-US",
        "@id": "https://enterprisetalk.com/#/schema/person/image/",
        "url":
          "https://secure.gravatar.com/avatar/1a2d9cbe6138fa895341ade5cf91e644?s=96&d=mm&r=g",
        "contentUrl":
          "https://secure.gravatar.com/avatar/1a2d9cbe6138fa895341ade5cf91e644?s=96&d=mm&r=g",
        "caption": postData[0].post_author
      },
      "description": postData[0].meta_description,
      "sameAs": [
        "https://enterprisetalk.com"
      ],
      "url": "https://enterprisetalk.com/"
    }
  ]

}


const meta = {
  title: postData[0].post_title,
  description: postData[0].post_title,
  image: `${webPath}${postData[0]?.banner_img}`,
  url: `https://enterprisetalk.com/${cat_slug}/${post_name}`,
  canonical: `https://enterprisetalk.com/${cat_slug}/${post_name}`,
  meta: {
    property: {
      'og:title': postData[0].post_title,
      'og:description': postData[0].post_title,
      'og:image': `${webPath}${postData[0]?.banner_img}`,
      'og:url': `https://enterprisetalk.com/${cat_slug}/${post_name}`,
    }
  }
};


// const handleClick = () => {
//   const instagramUrl = `https://enterprisetalk.com/${cat_slug}/${post_name}`;
//   window.open(instagramUrl, '_blank');
// };


const shareText = postData[0].post_title;
const shareUrl = `https://enterprisetalk.com/${cat_slug}/${post_name}`;

const instagramShareUrl = `https://www.instagram.com/?caption=${encodeURIComponent(shareText)}`;

const openSharePopup = (url) => {
  window.open(url, '_blank', 'width=600,height=400');
};

const handleInstagramShare = () => {
  openSharePopup(instagramShareUrl);
};






return (
  <div style={{ overflowX: "hidden" }}>
    <DocumentMeta {...meta} />

    <HelmetProvider>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schemaData, null, 2)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(schemaData2, null, 2)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(schemaData3, null, 2)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(schemaData4, null, 2)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(schemaData5, null, 2)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(schemaData6, null, 2)}
        </script>

        {/* <script type="application/ld+json">
            {JSON.stringify(schemaData1, null, 2)}
          </script> */}
      </Helmet>
    </HelmetProvider>

    <LazyLoad className={className}>
      <div className="container container-max ">
        <div className="row ">
          <div className="hr" style={{ padding: "0px" }}></div>

          <div className="col-md-9 borderR mt-2">
            {/* {postloading ? (
                <p></p>
              ) : ( */}
            <div>
              {/* Content for the 70% column */}
              <div className="paddings">
                {/* <p> {console.log('postdata '+ postData[0].post_title)}</p> */}
                <h1 className="fw-bold mt-1 h2 ">{postData[0].post_title}</h1>

                <div className="d-flex justify-content-between">
                  <div style={{ lineHeight: "2", width: "40%" }}>
                    {/* <p style={{ fontSize: "12px" }}>
                      By{" "}
                      <span className="fw-bold">{postData[0].post_author}</span>{" "}
                      | <span className="fw-bold">Last updated</span>{" "}
                      {new Date(postData[0].post_date).toLocaleDateString(
                        undefined,
                        options,
                      )}{" "}
                    </p> */}
                    <p style={{ fontSize: "12px" }}>
                      By{" "}
                      <span className="fw-bold">{postData[0].post_author}</span>{" "}
                      |{" "}
                      {postData[0].post_updated_date && (
                        <span className="fw-bold">Last updated : </span>
                      )}
                      {new Date(
                        postData[0].post_updated_date || postData[0].post_date,
                      ).toLocaleDateString(undefined, options)}
                    </p>
                  </div>

                  <div className="gap-1 d-flex">
                    <button className="share-btn">
                      <img
                        src={shareIcon}
                        alt="share"
                        style={{ width: "23px", padding: "1px" }}
                      />
                    </button>

                    {/* <SocialShare url={meta.url}  {...meta} /> */}
                    <SocialShare
                      url={meta.url}
                      title={postData[0].post_title}
                      img={`${webPath}${postData[0]?.banner_img}`}
                    />

                    <div className="share-button-container">
                      <button
                        onClick={handleInstagramShare}
                        className="instaBackColor"
                        style={{ border: "none", height: "27px" }}
                      >
                        <FontAwesomeIcon
                          icon={faInstagram}
                          style={{
                            fontSize: "17px",
                            color: "#fff",
                            marginTop: "4px",
                          }}
                        />
                      </button>
                      <span className="tooltip">Share on Instagram</span>
                    </div>
                  </div>
                </div>
              </div>
              {postData[0].banner_img && postData[0].banner_show === 1 && (
                <div className="mt-3">
                  <img
                    className="topicImg"
                    src={
                      isLoaded
                        ? src
                        : `${webPath}${postData[0]?.banner_img}?width=700`
                    }
                    alt={postData[0].post_title}
                  />
                </div>
              )}

              <div style={{ fontSize: "14px" }}>
                <p className="paddings">
                  {headings.length > 0 && (
                    <div
                      className={`contentTableBox mb-4 ${isFixed ? "fixed-top newTOC" : ""}`}
                      onClick={handleHeaderClick}
                    >
                      <h2 className="fw-bold px-1 h4 clippath">
                        <div className="d-flex justify-content-between">
                          <div className="mb-1" style={{ cursor: "pointer" }}>
                            Table of Contents
                          </div>
                          <div style={{ cursor: "pointer" }} className="px-2">
                            <FontAwesomeIcon icon={faBars} />
                          </div>
                        </div>
                      </h2>
                      <React.Fragment>
                        {accordionOpen && (
                          <ol className="px-3">
                            {headings.map((heading, index) => (
                              <li key={heading.id} className="tocBack">
                                <a
                                  href={`#${heading.id}`}
                                  onClick={(e) => {
                                    scrollToHeading(heading.id);
                                    handleLinkClick(e);
                                    setActiveHeadingId(heading.id);
                                    setAccordionOpen(false); // Close the accordion when a heading is clicked
                                  }}
                                  className={`text-black mb-1 backLine hover-underline-animations ${
                                    activeHeadingId === heading.id
                                      ? "actived"
                                      : ""
                                  }`}
                                >
                                  {heading.text}
                                </a>
                              </li>
                            ))}
                          </ol>
                        )}
                      </React.Fragment>
                    </div>
                  )}
                  {postData[0].podcast_link && (
                    <div className="video-responsive">
                      <iframe
                        width="560"
                        height="315"
                        src={`https://www.youtube.com/embed/${videoId}`}
                        title="YouTube video player"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                  )}

                  <div
                    className="content mt-2"
                    dangerouslySetInnerHTML={{ __html: updatedHtmlContent }}
                  />
                </p>
              </div>

              {/* Krishna */}

              <Accordian postDataFaq={faqData} />

              {/* Krishna */}

              <div
                className="ArticleBox mt-5 mb-5"
                style={{ alignItems: "center" }}
              >
                {loading ? (
                  <p></p>
                ) : (
                  <>
                    <div>
                      <img
                        className="ArticleImg"
                        src={`${webPath}${
                          authorData?.author_photo ||
                          "/uploads/author-profiles/Author-Image.jpg"
                        }?width=300`}
                        alt={authorData?.author_name}
                      />
                    </div>
                    <div style={{ fontSize: "12px", padding: "10px" }}>
                      <h2 className="fw-bold h6">
                        {authorData?.author_display_name}
                      </h2>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: authorData?.author_description,
                        }}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
            {/* )} */}

            <LazyLoad className={className1}>
              <h3 className="fw-bold borderB py-1 h5">
                More from Enterprise Talk
              </h3>
              {latestPosts.slice(0, 4).map((post, index) => (
                <a href={`/${post.cat_slug}/${post.post_name}`}>
                  {" "}
                  <div
                    className="d-flex mt-3 mb-3"
                    style={{ alignItems: "center" }}
                  >
                    <div className="quickImgBox">
                      <img
                        style={{ width: "90%", borderRadius: "14px" }}
                        src={`${webPath}${post?.banner_img}?width=300`}
                        alt={post.post_title}
                      />
                    </div>

                    <div className="" style={{ width: "74%" }}>
                      <h4 className="fw-bold hoverHead quickText h5">
                        {post.post_title}
                      </h4>
                      <p style={{ fontSize: "12px" }}>
                        By <span className="fw-bold">{post.post_author}</span> |{" "}
                        {new Date(
                          post.post_updated_date || post.post_date,
                        ).toLocaleDateString(undefined, options)}
                      </p>
                    </div>
                  </div>{" "}
                </a>
              ))}
            </LazyLoad>
          </div>

          <div className="col-md-3">
            <LazyLoad className={className}>
              <div className=" borderB paddings">
                <h5 className="fw-bold">Related Articles</h5>
              </div>
              <div>
                {data
                  .filter((post) => post.post_title !== postData[0].post_title)
                  .map((post, index) => (
                    <div key={index} className="paddings">
                      <a href={`/${post.cat_slug}/${post.post_name}`}>
                        <h5
                          className="fw-bold h5 hoverHead line-clamp"
                          title={post.post_title}
                        >
                          {post.post_title}
                        </h5>
                      </a>
                      <p style={{ fontSize: "12px" }}>
                        By <span className="fw-bold">{post.post_author}</span> |{" "}
                        {new Date(
                          post.post_updated_date || post.post_date,
                        ).toLocaleDateString(undefined, options)}
                      </p>

                      <div className="d-flex gap-3">
                        <div style={{ width: "90%" }}>
                          <p
                            className="just-text line-clamp mt-1"
                            style={{ fontSize: "15px" }}
                          >
                            {post.post_content}
                          </p>
                        </div>
                      </div>

                      <p className="hr" />
                    </div>
                  ))}
              </div>

              <AdCarousel ads={reportAdData} className={className} />
            </LazyLoad>
          </div>
        </div>
      </div>
    </LazyLoad>

    <LazyLoad className={className1}>
      <div className="container container-max ">
        <div className="row"></div>
      </div>
    </LazyLoad>

    <LazyLoad className={className2}>
      <div className="container container-max ">
        <div className="row mt-5 spaceincontentbottm">
          <div className="col-md-12 mb-2 borderB">
            {/* <div>
                {footerAd && footerAd.length > 0 && (
                  <a href={`${footerAd[0].dest_url}`} target="_blank">
                    {" "}
                    <img
                      style={{ width: "100%" }}
                      src={`${webPath}${footerAd[0]?.banner_img}`}
                      alt={footerAd[0].banner_name}
                    />{" "}
                  </a>
                )}
              </div> */}
            <AdCarousel ads={footerAd} className={className1} />
          </div>
        </div>
      </div>
    </LazyLoad>
  </div>
);
};

export default Searchart;